"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postAuthTokenValidation = void 0;
var utils_1 = require("./utils");
function postAuthTokenValidation(postAuthTokenRequest) {
    var errorList = [];
    var data = postAuthTokenRequest.data;
    if (!data.id) {
        utils_1.addErrorList(errorList, 'id', 'VIEW_LOGIN_ID_ISNULL_ERROR');
    }
    if (!data.password) {
        utils_1.addErrorList(errorList, 'password', 'VIEW_LOGIN_PW_ISNULL_ERROR');
    }
    return errorList;
}
exports.postAuthTokenValidation = postAuthTokenValidation;
